
import Promocao from './promocao'
import Promocoes from './promocoes'
import CriarPromocao from './criarPromocao'
import BuscarServicosByNome from './servicos'
import DeletarPromocao from './deletarPromocao'

export default {
    Promocao, 
    Promocoes, 
    CriarPromocao,
    BuscarServicosByNome, 
    DeletarPromocao
}